// extracted by mini-css-extract-plugin
export default {"quick":"ShoesProductsInfo_quick__+OS1c","image":"ShoesProductsInfo_image__dN99L"};